import { combineReducers } from 'redux'
import bank_reducer from './bank_reducer'
import account_manager_reducer from './account_manager_reducer'
import bin_reducer from './bin_reducer'
import category_reducer from './category_reducer'
import customer_reducer from './customer_reducer'
import item_reducer from './item_reducer'
import reject_reducer from './reject_reducer'
import store_reducer from './store_reducer'
import supplier_reducer from './supplier_reducer'
import terms_conditions_reducer from './terms_conditions_reducer'
import unit_reducer from './unit_reducer'
import invoice_print_title_reducer from './settings/invoice_print_title_reducer'
import purchase_setting_reducer from './settings/purchase_setting_reducer'
import invoice_setting_reducer from './settings/invoice_setting_reducer'
import doc_no_format_reducer from './settings/doc_no_format_reducer'
import user_management_reducer from './settings/user_management_reducer'
import company_reducer from './settings/company_reducer'
import delivery_challan_reducer from './sales/delivery_challan_reducer'
import proforma_invoice_reducer from './sales/proforma_invoice_reducer'
import quotation_reducer from './sales/quotation_reducer'
import customer_supplier_advance_payment_reducer from './payment/customer_supplier_advance_payment_reducer'
import sales_invoice_reducer from './sales/sales_invoice_reducer'
import sales_order_reducer from './sales/sales_order_reducer'
import sales_return_reducer from './sales/sales_return_reducer'
import purchase_invoice_reducer from './purchase/purchase_invoice_reducer'
import purchase_order_reducer from './purchase/purchase_order_reducer'
import purchase_return_reducer from './purchase/purchase_return_reducer'
import customer_supplier_CNS_reducer from './customer_supplier_CNS_reducer'
import states_reducer from './states_reducer'
import customer_supplier_payment_reducer from './payment/customer_supplier_payment_reducer'
import payment_invoice_deduction_reducer from './payment/payment_invoice_deduction_reducer'
import mailSetup_reducer from './mailSetup_reducer'
import account_statement_report_reducer from './reports/account_statement_report_reducer'
import gst_register_report_reducer from './reports/gst_register_report_reducer'
import outstanding_report_reducer from './reports/outstanding_report_reducer'
import payment_register_report_reducer from './reports/payment_register_report_reducer'
import purchase_order_history_report_reducer from './reports/purchase_order_history_report_reducer'
import purchase_register_report_reducer from './reports/purchase_register_report_reducer'
import sales_order_history_report_reducer from './reports/sales_order_history_report_reducer'
import sales_register_report_reducer from './reports/sales_register_report_reducer'
import printSetup_reducer from './settings/printSetup_reducer'
import dashboard_reducer from './dashboard_reducer'
import production_reducer from './production/production_reducer'
import menu_setting_reducer from './settings/menu_setting_reducer'
import notification_reducer from './notification_reducer'

export default combineReducers({
    // ---------------masters------------
    allStates: states_reducer,
    bank: bank_reducer,
    accountManager: account_manager_reducer,
    bin: bin_reducer,
    category: category_reducer,
    customer: customer_reducer,
    item: item_reducer,
    reject: reject_reducer,
    store: store_reducer,
    supplier: supplier_reducer,
    termsConditions: terms_conditions_reducer,
    unit: unit_reducer,
    // -----------SETTINGS ----------
    invoicePrintTitle: invoice_print_title_reducer,
    purchaseSetting: purchase_setting_reducer,
    invoiceSetting: invoice_setting_reducer,
    menuSetting:menu_setting_reducer,
    docNoFormate: doc_no_format_reducer,
    userManagement: user_management_reducer,
    company: company_reducer,
    CNS: customer_supplier_CNS_reducer,
    printSetup: printSetup_reducer,
    notifications: notification_reducer,


    // ----------PURCHASE-----------
    purchaseInvoice: purchase_invoice_reducer,
    purchaseOrder: purchase_order_reducer,
    purchaseReturn: purchase_return_reducer,
    mailSetup: mailSetup_reducer,
    

    // ----------SALES---------------
    deliveryChallan: delivery_challan_reducer,
    ProformaInvoice: proforma_invoice_reducer,
    quotation: quotation_reducer,
    customer_supplier_advancePayment: customer_supplier_advance_payment_reducer,
    customer_supplier_payment: customer_supplier_payment_reducer,
    paymentInvoiceDeduction: payment_invoice_deduction_reducer,
    saleInvoice: sales_invoice_reducer,
    salesOrder: sales_order_reducer,
    salesReturn: sales_return_reducer,

     // ----------Reports---------------
     accountStatement: account_statement_report_reducer,
     GSTRegister: gst_register_report_reducer,
     outstanding: outstanding_report_reducer,
     paymentRegister: payment_register_report_reducer,
     purchaseOrderHistory: purchase_order_history_report_reducer,
     purchaseRegister: purchase_register_report_reducer,
     salesOrderHistory: sales_order_history_report_reducer,
     salesRegister: sales_register_report_reducer,

     // ----------Dashboard---------------
     dashboard: dashboard_reducer,
      // ----------Production---------------
      production: production_reducer,
})